import { render, staticRenderFns } from "./RemoveProfessionalInfoModal.vue?vue&type=template&id=37da2624"
import script from "./RemoveProfessionalInfoModal.vue?vue&type=script&lang=js"
export * from "./RemoveProfessionalInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports